<template>
    <div>
        <banner-thanks v-if="result.banner" :result="result.banner" />
        <div class="checkout-thanks__grid">
            <div class="checkout-thanks__col">
                <div class="checkout-thanks__col-wrapper">
                    <h5 class="def-title-5">{{ result.messages.orderSuccessTitle }}</h5>
                    <checkout-confirmation v-if="result.confirmation" :result="result.confirmation" />
                </div>
            </div>
            <div class="checkout-thanks__col">
                <checkout-information :thanksPage="true" :result="result" />
            </div>
        </div>
    </div>
</template>

<script>
    // const item = require('../../../MOCKED_DATA/good-item').goodItem;
    // const totalPrice = require('../../../MOCKED_DATA/total-price').totalPrice;
    export default {
        name: 'checkout-thanks',
        selector: '.checkout-thanks',
        props: {
            result: {
                type: Object,
                default: () => {
                    return {
                        messages: {
                            orderSuccessTitle: 'Інформація про замовлення',
                        }
                    }
                }
            }
        },
        mounted() {
          console.log(this.result)
            if (App.debug) {
                console.log('Component: checkout-thanks', this.result);
            }
        }
    }


</script>

<style lang="scss">
    .checkout-thanks{
        margin-bottom: 56px;
        @include point-md{
            margin-bottom: 80px;
        }
        &__grid{
            display: grid;
            grid-template-columns: 1fr;
            grid-column-gap: 4px;
            @include point-lg{
                grid-template-columns: 67% 33%;
            }
        }
        &__col-wrapper{
            padding: 24px;
            background-color: #fff;
            margin-bottom: 4px;
            height: 100%;
        }
        .def-title-5{
            margin-bottom: 24px;
        }
    }
</style>